import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const OneDriveIcon = svgProps => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 5.5 32 20.5",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 20.5),
    ...svgProps,
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.20245,11.19292l.00031-.0011,6.71765,4.02379,4.00293-1.68451.00018.00068A6.4768,6.4768,0,0,1,25.5,13c.14764,0,.29358.0067.43878.01639a10.00075,10.00075,0,0,0-18.041-3.01381C7.932,10.00215,7.9657,10,8,10A7.96073,7.96073,0,0,1,12.20245,11.19292Z",
      fill: "#0364b8"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.20276,11.19182l-.00031.0011A7.96073,7.96073,0,0,0,8,10c-.0343,0-.06805.00215-.10223.00258A7.99676,7.99676,0,0,0,1.43732,22.57277l5.924-2.49292,2.63342-1.10819,5.86353-2.46746,3.06213-1.28859Z",
      fill: "#0078d4"
    }), /*#__PURE__*/jsx("path", {
      d: "M25.93878,13.01639C25.79358,13.0067,25.64764,13,25.5,13a6.4768,6.4768,0,0,0-2.57648.53178l-.00018-.00068-4.00293,1.68451,1.16077.69528L23.88611,18.19l1.66009.99438,5.67633,3.40007a6.5002,6.5002,0,0,0-5.28375-9.56805Z",
      fill: "#1490df"
    }), /*#__PURE__*/jsx("path", {
      d: "M25.5462,19.18437,23.88611,18.19l-3.80493-2.2791-1.16077-.69528L15.85828,16.5042,9.99475,18.97166,7.36133,20.07985l-5.924,2.49292A7.98889,7.98889,0,0,0,8,26H25.5a6.49837,6.49837,0,0,0,5.72253-3.41556Z",
      fill: "#28a8ea"
    })]
  });
};

export { OneDriveIcon };
//# sourceMappingURL=one-drive.js.map
